import { render, staticRenderFns } from "./StatusHeader.vue?vue&type=template&id=350ab03b&scoped=true"
import script from "./StatusHeader.vue?vue&type=script&lang=js"
export * from "./StatusHeader.vue?vue&type=script&lang=js"
import style0 from "./StatusHeader.vue?vue&type=style&index=0&id=350ab03b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350ab03b",
  null
  
)

export default component.exports